var module;
// LICENSE_CODE ZON
'use strict'; /*jslint node:true, browser:true*/
var is_node = !!(typeof module == 'object' && module.exports);
define(['/svc/billing/pub/payutils.js', '/util/country.js', '/util/etask.js', 'lodash'], function (payutils, zcountry, etask, _) {
  var E = {};

  // container: HTMLElement
  // params (core):
  //   sbx: true/false
  //   form_prerender: ()=>{}
  //   form_render: (root, {session_id, add_validation})=>{}
  //   err_render: (err_msg, id)=>{}
  //   form_submit: (form_data)=>{}
  //   perr_context: object or ()=>{}
  // params (callbacks):
  //   on_validate: (id, err)=>{}
  //   on_pending: ()=>{}
  //   on_submit_success: result=>{}
  //   on_submit_failure: err=>{}
  //   on_error: err=>{}
  //   on_retry: err=>{}
  E.render_ccard_form = function (container, params, design_2) {
    if (!params.form_render || !params.form_submit) throw new Error('Invalid params');
    // error handling
    var handle_error = function handle_error(e, context) {
      payutils.report_error('ccard_form_error', e, Object.assign({
        location: '' + window.location
      }, _.pick(params, 'customer'), resolve_if_func(params.perr_context), !e.hola_info ? null : {
        xhr_info: e.hola_info
      }, context));
      (params.on_error || _.noop)(e);
    };
    var resolve_if_func = function resolve_if_func(v) {
      return typeof v == 'function' ? v() : v;
    };
    // render form in loading state
    var form_el = document.createElement('form'),
      session_id;
    var validator = {},
      global_err_div,
      issuer;
    var set_global_error = function set_global_error(err) {
      if (err != null) {
        if (err && !global_err_div) {
          global_err_div = document.createElement('div');
          global_err_div.className = 'submit_err alert-danger alert';
          form_el.appendChild(global_err_div);
        }
        global_err_div.innerHTML = err;
      } else {
        if (global_err_div) global_err_div.parentNode.removeChild(global_err_div);
        global_err_div = null;
      }
    };
    form_el.autocomplete = 'off';
    if (design_2) form_el.className = 'issuer-unknown loading';else form_el.className = 'ccard_form issuer-unknown loading';
    form_el.innerHTML = 'Loading...';
    container.appendChild(form_el);
    return etask([function () {
      this.on('uncaught', function (e) {
        handle_error(e, {
          action: 'init_form/init'
        });
      });
      return payutils.get_session_id();
    }, function (sid) {
      session_id = sid;
      return (params.form_prerender || _.noop)(params, {
        session_id: sid
      });
    }, function (sid) {
      // form validator
      var sub_validators = [];
      validator.is_valid = function (id) {
        if (id) {
          var sub = validator.find_sub(id);
          return sub && sub.is_valid();
        }
        return sub_validators.every(function (v) {
          return v.is_ignored() || v.is_valid();
        });
      };
      validator.is_ignored = function (id) {
        var sub = validator.find_sub(id);
        return sub && sub.is_ignored();
      };
      validator.find_sub = function (id) {
        return sub_validators.find(function (v) {
          return v.id == id;
        });
      };
      validator.revalidate = function (id, opt) {
        if (opt === undefined && id != null && typeof id == 'object') {
          opt = id;
          id = null;
        }
        sub_validators.forEach(function (v) {
          if (id == null || v.id == id) v.revalidate(opt);
        });
      };
      validator.add = function (id, fn) {
        try {
          var root_el = form_el.querySelector('.' + id + '_field');
          var cur_err, msg_el;
          var sub_validator = {
            id: id
          };
          sub_validator.is_ignored = function () {
            return payutils.has_class(root_el.parentNode, 'hidden');
          };
          sub_validator.is_valid = function () {
            return !cur_err;
          };
          sub_validator.revalidate = function (opt) {
            try {
              var err = fn ? fn(input_el.value, input_el) : cur_err;
              sub_validator.set_error(err, opt);
            } catch (e) {
              handle_error(e, {
                action: 'sub_validator/validate',
                field_id: id
              });
            }
          };
          sub_validator.set_valid = function (opt) {
            sub_validator.set_error(null, opt);
          };
          sub_validator.set_error = function (err, opt) {
            try {
              cur_err = err;
              payutils.toggle_class(root_el, 'valid', !err);
              payutils.toggle_class(root_el, 'invalid', !!err);
              if (err && (opt && opt.ignore_pristine || !payutils.has_class(root_el, 'pristine'))) {
                if (!msg_el) {
                  msg_el = document.createElement('span');
                  msg_el.className = 'err_msg';
                  root_el.appendChild(msg_el);
                }
                var msg = (params.err_render || _.identity)(err, id);
                msg_el.innerHTML = msg;
              } else if (!err && msg_el) {
                msg_el.parentNode.removeChild(msg_el);
                msg_el = null;
              }
              (params.on_validate || _.noop)(id, err);
            } catch (e) {
              handle_error(e, {
                action: 'sub_validator/set_error',
                field_id: id
              });
            }
          };
          sub_validator.get_error = function () {
            return cur_err;
          };
          sub_validator.set_dirty = function () {
            payutils.remove_class(root_el, 'pristine');
            payutils.add_class(root_el, 'dirty');
            sub_validator.revalidate();
          };
          payutils.add_class(root_el, 'pristine');
          sub_validators.push(sub_validator);
          // auto-handling for actual inputs
          var input_el = root_el.querySelector('input.hola_input,select.hola_input');
          if (input_el) {
            var validate = sub_validator.revalidate;
            var debounced_validate = _.debounce(function () {
              set_global_error(null);
              validate();
            }, 25);
            input_el.onfocus = function () {
              validate();
            };
            input_el.oninput = function () {
              debounced_validate();
            };
            input_el.oncut = function () {
              debounced_validate();
            };
            input_el.onpaste = function () {
              debounced_validate();
            };
            input_el.onchange = function () {
              validate();
            };
            input_el.onblur = function () {
              sub_validator.set_dirty();
            };
            validate();
          }
          return sub_validator;
        } catch (e) {
          handle_error(e, {
            action: 'validator/add',
            field_id: id
          });
        }
      };
      validator.watch = function (id, change_cb) {
        try {
          var root_el = form_el.querySelector('.' + id + '_field');
          var input_el = root_el.querySelector('.hola_input');
          var cb = function cb() {
            change_cb(input_el.value, input_el);
          };
          var deb_cb = _.debounce(cb, 25);
          input_el.addEventListener('focus', function () {
            cb();
          });
          input_el.addEventListener('input', function () {
            deb_cb();
          });
          input_el.addEventListener('cut', function () {
            deb_cb();
          });
          input_el.addEventListener('paste', function () {
            deb_cb();
          });
          cb();
        } catch (e) {
          handle_error(e, {
            action: 'validator/watch',
            field_id: id
          });
        }
      };
      // form render
      return params.form_render(form_el, {
        session_id: session_id,
        set_issuer: function set_issuer(v) {
          issuer = form_el.issuer = v;
        },
        add_validation: validator.add,
        revalidate: validator.revalidate,
        watch: validator.watch,
        find: validator.find_sub,
        set_global_error: set_global_error,
        handle_error: handle_error,
        form_el: form_el
      });
    }, function () {
      payutils.remove_class(form_el, 'loading');
      var cvv_placeholder = form_el.querySelector('.ccard_cvv_field .hola_input').placeholder;
      if (!cvv_placeholder || /^1234?$/.test(cvv_placeholder)) cvv_placeholder = '123456';else if (cvv_placeholder) cvv_placeholder = _.pad('', 6, cvv_placeholder.charAt(0));
      // number/exp/cvv validation
      if (params.setup_default_validation != false) {
        validator.add('ccard_number', function (v, el) {
          v = v.replace(/\s/g, '');
          var result = E.validate_ccard(v);
          // issuer update
          if (issuer != result.issuer) {
            issuer = form_el.issuer = result.issuer;
            // issuer css class update
            var issuer_class = 'issuer-' + (issuer && issuer.id || 'unknown');
            var classes = form_el.className.split(/\s+/).filter(Boolean).filter(function (c) {
              return !c.startsWith('issuer-');
            });
            classes.push(issuer_class);
            payutils.set_classes(form_el, classes);
            // cvv updates
            var cvv_field = form_el.querySelector('.ccard_cvv_field .hola_input');
            var cvv_len = issuer && issuer.cvv_length || 3;
            cvv_field.placeholder = cvv_placeholder.substr(0, cvv_len);
            cvv_validator.revalidate();
          }
          // normalize value
          el.value = E.format_ccard(v, issuer);
          // validation
          if (!v) return '* required';
          if (!/^[0-9]+$/.test(v)) return 'invalid format';
          if (!result.partial_valid && !params.sbx) return 'invalid card number';
          if (!result.valid && !params.sbx) return 'incomplete';
        });
        var prev_exp = '';
        validator.add('ccard_exp', function (v, el) {
          var groups;
          // normalize value
          v = v.replace(/^\s+/, '').replace(/\s+$/, '');
          if (groups = /^(([0-9]{2})\/?){0,1}([0-9]{0,2})$/.exec(v)) {
            if (groups[1] && !groups[1].includes('/') && !groups[3]) v = groups[2] + (prev_exp.includes('/') ? '' : '/');else if (groups[2] && groups[2].length >= 2) v = groups[2] + '/' + (groups[3] || '');else v = groups[1] || groups[3];
          }
          el.value = prev_exp = v;
          // validate value
          if (!_.trim(v)) return '* required';
          if (!groups) return 'format should be MM/YY';
          if (v.length < 5) return 'incomplete';
          var month = +v.split('/')[0];
          var year = +v.split('/')[1];
          if (isNaN(month) || month < 1 || month > 12) return 'invalid month';
          if (isNaN(year)) return 'invalid year';
          var cur_year = new Date().getFullYear() - 2000;
          var cur_month = new Date().getUTCMonth() + 1;
          if (year < cur_year || year == cur_year && month < cur_month) return 'card is expired';
        });
        var cvv_validator = validator.add('ccard_cvv', function (v, el) {
          v = el.value = v.replace(/^\s+/, '').replace(/\s+$/, ' ');
          if (!_.trim(v)) return 'should not be empty';
          var cvv_len = issuer && issuer.cvv_length || 4;
          if (!/^[0-9]*$/.test(v) || v.length != cvv_len) return 'should be ' + cvv_len + ' digit number';
        });
      }
      // form submission
      var get_form_data = function get_form_data() {
        var form_data = {};
        payutils.to_array(form_el.querySelectorAll('input,select')).forEach(function (el) {
          if (el.name && !validator.is_ignored(el.name)) form_data[el.name] = _.trim(el.value);
        });
        if (form_data.ccard_exp && /^\d{2}\/\d{2}$/.test(form_data.ccard_exp)) {
          var ccard_exp = form_data.ccard_exp;
          form_data.ccard_exp_year = '20' + ccard_exp.split('/')[1];
          form_data.ccard_exp_month = ccard_exp.split('/')[0];
        }
        return form_data;
      };
      var lock_state = {};
      var lock_form = function lock_form(is_on) {
        payutils.to_array(form_el.querySelectorAll('input,select')).forEach(function (el) {
          if (is_on) {
            lock_state[el.name] = el.disabled;
            el.disabled = true;
          } else el.disabled = lock_state[el.name];
        });
      };
      var submitting = false;
      var submit_form = function submit_form(opt) {
        try {
          if (submitting) return false;
          if (!validator.is_valid()) {
            if (!form_el.dirty_submit_btn) validator.revalidate({
              ignore_pristine: 1
            });
            form_el.dirty_submit_btn = true;
            return false;
          }
          if (params.can_submit && !params.can_submit(form_el)) return false;
          submitting = true;
          payutils.add_class(form_el, 'submitting');
        } catch (e) {
          handle_error(e, {
            action: 'submit_form/validate'
          });
          return false;
        }
        var submit_err;
        return etask([function () {
          this.on('uncaught', function (e) {
            handle_error(e, {
              action: 'submit_form/uncaught'
            });
          });
          (params.on_pending || _.noop)(this);
          // gather form data
          var form_data = get_form_data();
          lock_form(true);
          // run form submission
          set_global_error(null);
          return etask([function () {
            return params.form_submit(form_data, {
              session_id: session_id,
              issuer: issuer,
              form_el: form_el
            }, params, opt);
          }, function catch$(e) {
            submit_err = e;
          }]);
        }, function (result) {
          if (submit_err) {
            if (submit_err.xhr && submit_err.xhr.status >= 400) submit_err.no_report = true;
            if (!submit_err.no_report) {
              handle_error(submit_err, {
                action: 'submit_form/callback'
              });
            } else (params.on_error || _.noop)(submit_err);
            var e_render = params.submit_err_render;
            var global_err_msg = e_render && e_render(submit_err, 'ccard_retry') || submit_err.message || 'Unexpected error';
            if (params.on_retry && !submit_err.no_retry && !e_render) {
              global_err_msg += '.<br>Please <strong ' + 'id=ccard_retry>try again</strong>';
              if (submit_err.suspicious) {
                global_err_msg += ' or contact your bank or card ' + 'issuer to verify the payment.';
              }
            }
            var help_email;
            if (submit_err.fraud) help_email = 'billing2@hola.org';
            if (help_email) {
              global_err_msg += '. If you need assistance, contact ' + 'us at <a href="mailto:' + help_email + '">' + help_email + '</a>';
            }
            set_global_error(global_err_msg);
            if (params.on_retry && !submit_err.no_retry) {
              var retry_a = document.getElementById('ccard_retry');
              if (retry_a) {
                retry_a.onclick = function () {
                  params.on_retry(submit_err);
                };
              }
            }
            return (params.on_submit_failure || _.noop)(submit_err);
          }
          return (params.on_submit_success || _.noop)(result);
        }, function (v) {
          // on_submit_* handlers can override success status
          return v != null ? !!v : !submit_err;
        }, function finally$() {
          try {
            submitting = false;
            payutils.remove_class(form_el, 'submitting');
            lock_form(false);
          } catch (e) {
            handle_error(e, {
              action: 'submit_form/finally'
            });
          }
        }]);
      };
      form_el.onsubmit = function (evt) {
        try {
          if (evt.preventDefault) evt.preventDefault();else evt.returnValue = false;
          submit_form();
        } catch (e) {
          handle_error(e, {
            action: 'submit_form/html_evt'
          });
        }
        return false;
      };
      // form controls
      return {
        submit: submit_form,
        is_valid: validator.is_valid,
        get_data: get_form_data,
        revalidate: validator.revalidate
      };
    }]);
  };
  E.format_ccard = function (val, issuer) {
    var ends_with_space = /\s$/.test(val);
    var gaps = issuer && issuer.gaps || [4, 8, 12];
    var res = '',
      start_idx = 0;
    for (var i = 0; i < gaps.length; i++) {
      var gap_idx = gaps[i];
      if (gap_idx >= val.length) break;
      res += val.substring(start_idx, gap_idx) + ' ';
      start_idx = gap_idx;
    }
    res += val.substring(start_idx);
    if (ends_with_space) res += ' ';
    return res;
  };
  E.validate_ccard = function (val) {
    val = ('' + val).replace(/-|\s/g, '');
    if (!val) return {
      valid: 0,
      partial_valid: 1,
      issuer: null
    };
    if (!/^\d*$/.test(val)) return {
      valid: 0,
      partial_valid: 0,
      issuer: null
    };
    var matches = E.issuers.filter(function (x) {
      return x.is_match(val);
    });
    if (!matches.length && val.length >= E.nil_issuer.min_length && luhn10(val)) matches = [E.nil_issuer];
    var issuer = matches.length == 1 && matches[0] || null;
    var valid = !!issuer && issuer.lengths.includes(val.length) && (issuer.luhn10 == false || luhn10(val));
    return {
      length: val.length,
      valid: valid,
      partial_valid: valid || val.length < (issuer && issuer.min_length || 6),
      issuer: issuer
    };
  };

  // https://en.m.wikipedia.org/wiki/Luhn_algorithm
  function luhn10(str) {
    var sum = 0,
      double = false;
    for (var i = str.length - 1; i >= 0; i--) {
      var v = +str.charAt(i);
      if (double) {
        v *= 2;
        if (v > 9) v = 1 + v % 10;
      }
      sum += v;
      double = !double;
    }
    return sum % 10 == 0;
  }

  // -- issuers (https://en.wikipedia.org/wiki/Payment_card_number) --
  E.issuers = [];
  E.get_issuer = function (v) {
    v = v == null ? '' : '' + v;
    if (/^[0-9][0-9 ]*$/.test(v)) {
      v = v.replace(/\s/g, '');
      var matches = E.issuers.filter(function (x) {
        return x.is_match(v);
      });
      return matches.length == 1 ? matches[0] : undefined;
    }
    v = v.toLowerCase().trim().replace(/\s+/g, '_').replace(/[,'"]/g, '').replace(/^credit_card_/, '').replace(/(_[0-9*]+)*$/, '');
    var match;
    if (match = _.find(E.issuers, function (x) {
      return x.id == v;
    })) return match;
    if (match = _.find(E.issuers, function (x) {
      return x.aliases.includes(v);
    })) return match;
    return _.find(E.issuers, function (x) {
      return x.aliases.some(function (a) {
        return v.startsWith(a + '_');
      });
    });
  };
  (function () {
    function add_issuer(issuer) {
      issuer.aliases = [issuer.id].concat(issuer.aliases || []);
      issuer.cvv_length = issuer.cvv_length || 3;
      issuer.min_length = Math.min.apply(null, issuer.lengths);
      issuer.max_length = Math.max.apply(null, issuer.lengths);
      E.issuers.push(issuer);
      return issuer;
    }
    E.nil_issuer = add_issuer({
      id: 'unknown',
      aliases: ['unknown_issuer'],
      label: 'Unknown Issuer',
      is_match: function is_match() {
        return false;
      },
      lengths: [12, 13, 14, 15, 16, 17, 18, 19],
      cvv_length: 4
    });
    add_issuer({
      id: 'visa',
      aliases: ['dankort_visa'],
      label: 'Visa',
      is_match: compile_match_func(['4']),
      lengths: [16, 18, 19],
      cvv_length: 3
    });
    add_issuer({
      id: 'mastercard',
      aliases: ['master_card'],
      label: 'Mastercard',
      is_match: compile_match_func(['222[1-9][0-9][0-9]',
      // 222 100–222 999
      '22[3-9][0-9][0-9][0-9]',
      // 223 000–229 999
      '2[3-6][0-9][0-9][0-9][0-9]',
      // 230 000–269 999
      '27[0-1][0-9][0-9][0-9]',
      // 270 000–271 999
      '2720[0-9][0-9]',
      // 272 000–272 099
      '5[1-5]']),
      lengths: [16],
      cvv_length: 3
    });
    add_issuer({
      id: 'amex',
      aliases: ['american_express'],
      label: 'American Express',
      is_match: compile_match_func(['3[47]']),
      lengths: [15],
      gaps: [4, 10],
      cvv_length: 4
    });
    add_issuer({
      id: 'discover',
      label: 'Discover',
      is_match: compile_match_func(['6011', '6[45]']),
      lengths: [16, 19],
      cvv_length: 3
    });
    add_issuer({
      id: 'maestro',
      label: 'Maestro',
      is_match: compile_match_func(['50', '5[6-8]', '639', '67']),
      lengths: [12, 13, 14, 15, 16, 17, 18, 19],
      cvv_length: 3
    });
    add_issuer({
      id: 'jcb',
      label: 'JCB',
      is_match: compile_match_func(['352[8-9]',
      // 3528-3529
      '35[3-8][0-9]' // 3530-3589
      ]),
      lengths: [16, 17, 18, 19],
      cvv_length: 3
    });
    add_issuer({
      id: 'diners',
      aliases: ['diners_club'],
      label: 'Diners Club',
      is_match: compile_match_func(['30[0-5]', '3095', '3[689]']),
      lengths: [14, 16, 19],
      gaps: [4, 10],
      cvv_length: 3
    });
    function compile_match_func(prefixes) {
      var regexes = prefixes.map(get_prefix_regex);
      return function (v) {
        return regexes.some(function (p) {
          return p.test(v);
        });
      };
    }
    function get_prefix_regex(prefix) {
      // input: "12[4-9]", output: /^(1(2([4-9]\d*)?)?)?$/
      var re_start = '',
        re_end = '\\d*';
      var from_idx = 0,
        to_idx;
      while (from_idx < prefix.length) {
        if (prefix.charAt(from_idx) == '[') to_idx = prefix.indexOf(']', from_idx + 1) + 1;else to_idx = from_idx + 1;
        re_start += '(' + prefix.substring(from_idx, to_idx);
        re_end += ')?';
        from_idx = to_idx;
      }
      return new RegExp('^' + re_start + re_end + '$');
    }
  })();
  return E;
});